import React, { useEffect, useContext, useState, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AppSettings } from './../../config/app-settings.js';
import { Icon } from '@iconify/react';
import Highlight from 'react-highlight';

function AiChat() {
	const context = useContext(AppSettings);
	const [activeTab, setActiveTab] = useState("aiChatIntro");
  const [messages, setMessages] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const messagesRef = useRef(null);

  const toggleAiTab = (e, tabActive, input) => {
    setActiveTab(tabActive);
    
    if (e && e.currentTarget && tabActive === 'aiChatPrev') {
    	const targetDiv = e.currentTarget.closest('div');
    	if (targetDiv) {
    		setTimeout(() => {
					targetDiv.classList.toggle('bg-light');
					
					let prevTabs = document.querySelectorAll('[data-toggle-ai-tab="aiChatPrev"]');
					prevTabs.forEach(el => {
						const parentDiv = el.closest('div');
						if (parentDiv && parentDiv !== targetDiv) {
							parentDiv.classList.remove('bg-light');
						}
					});
				}, 10);
    	}
    }

    if (input) {
      aiSendMessage(input);
    }

    setTimeout(() => {
      if (messagesRef.current) {
        messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
      }
    }, 50);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSendMessage = () => {
    if (inputValue.trim() !== "") {
    	toggleAiTab(null, 'aiChatNew', inputValue);
      setInputValue("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  const aiResponses = [
    "That's an interesting question! Let me think...",
    "Good point! What else do you think about this?",
    "That makes sense. Can you clarify a bit more?",
    "Great perspective! Here’s my take on it...",
    "Good question! I believe the answer is...",
    "I appreciate your input! Let’s explore this further.",
    "That's a unique thought! Here’s another angle to consider...",
    "Nice one! Have you considered looking at it from this perspective?",
  ];

  const aiSendMessage = (input) => {
    if (!input) return;

    setMessages((prev) => [
      ...prev,
      { type: "user", text: input },
      { type: "typing" }
    ]);

    setTimeout(() => {
      setMessages((prev) =>
        prev.filter((msg) => msg.type !== "typing").concat({
          type: "ai",
          text: aiResponses[Math.floor(Math.random() * aiResponses.length)],
        })
      );
    }, 2000);
  };
	
	useEffect(() => {
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-0 d-flex bg-component h-100');
		context.setAppVh100(true);
		
		return function cleanUp() {
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
			context.setAppVh100(false);
		}
		
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<a className="d-lg-none btn btn-icon btn-lg bg-white bg-opacity-15 bg-blur-3 text-body z-3 mt-50px position-absolute top-0 start-0 " data-bs-toggle="offcanvas" href="#aiChatSidebar" role="button" aria-controls="offcanvasExample">
				<i className="fa fa-gear"></i>
			</a>
			
			<div className="w-250px bg-none offcanvas offcanvas-start position-lg-relative transform-lg-none visibility-lg-initial z-lg-3" id="aiChatSidebar">
				<div className="bg-white bg-opacity-10 bg-blur-2 d-lg-none d-block position-absolute top-0 end-0 w-100 h-100"></div>
				
				<div className="position-relative h-100 d-flex flex-column pe-2px">
					<div className="p-3 bg-white bg-opacity-15 mb-2px">
						<button type="button" className="btn py-2 btn-theme border-0 w-100" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatIntro');}}><i className="fa fa-plus me-2 ms-n3 my-4px"></i> New Chat</button>
					</div>
					
					<div className="flex-1 overflow-hidden text-body bg-white bg-opacity-10">
						<PerfectScrollbar className="p-3 h-100">
							<div className="fw-bold small mb-2 d-flex align-items-center">
								<Icon icon="ph:calendar-blank-duotone" className="fs-16px w-18px me-7px pb-2px text-theme"></Icon> 
								TODAY
							</div>
							<div className="fs-11px">
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Plan My Dream Vacation</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="text-body text-opacity-50 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Craft a Winning Pitch</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="text-body text-opacity-50 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Organize My Day</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Write Custom Code</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Draft a Polished Email</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Brainstorm Ideas</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
							</div>
								
							<div className="fw-bold small mb-2 d-flex align-items-center mt-4">
								<Icon icon="ph:calendar-blank-duotone" className="fs-16px w-18px me-7px pb-2px text-theme"></Icon>
								1 Week Ago
							</div>
							<div className="fs-11px">
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Summarize an Article</div><a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Prepare for a Speech</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Create a Business Proposal</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
							</div>
							
							<div className="fw-bold small mb-2 d-flex align-items-center mt-4">
								<Icon icon="ph:calendar-blank-duotone" className="fs-16px w-18px me-7px pb-2px text-theme"></Icon> 
								2 Weeks Ago
							</div>
							<div className="fs-11px">
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Organize Project Tasks</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Research Market Trends</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Craft Social Media Posts</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Design My Personal Website</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
							</div>
							<div className="fw-bold small mb-2 d-flex align-items-center mt-4">
								<Icon icon="ph:calendar-blank-duotone" className="fs-16px w-18px me-7px pb-2px text-theme"></Icon> 
								3 Weeks Ago
							</div>
							<div className="fs-11px">
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Build a Content Calendar</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Write a Product Description</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Draft a Team Newsletter</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Set Monthly Goals</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
								<div className="position-relative hover-bg-white bg-opacity-10 hover-show py-5px px-3 ps-25px border-0 d-flex align-items-center">
									<div className="flex-1 text-body text-opacity-75">Create a Brand Style Guide</div>
									<a href="#/" className="stretched-link text-decoration-none" data-toggle-ai-tab="aiChatPrev" onClick={(e) => { e.preventDefault(); toggleAiTab(e, 'aiChatPrev');}}>&nbsp;</a>
									<div className="dropdown position-relative z-3">
										<a href="#/" data-bs-toggle="dropdown" className="link-gray-500 d-none hover-show-elm"><i className="fa fa-ellipsis"></i></a>
										<div className="dropdown-menu">
											<a href="#/" className="dropdown-item">Share Chat</a>
											<a href="#/" className="dropdown-item">See Details</a>
											<div className="dropdown-divider"></div>
											<a href="#/" className="dropdown-item">Rename</a>
											<a href="#/" className="dropdown-item">Archive</a>
											<a href="#/" className="dropdown-item">Delete</a>
										</div>
									</div>
								</div>
							</div>
						</PerfectScrollbar>
					</div>
					
					<div className="p-2 my-2px bg-white bg-opacity-15 mb-2px fs-11px fw-semibold">
						<div className="py-7px px-2 d-flex align-items-center">
							<i className="far fa-folder fa-lg fa-fw me-7px"></i>
							EXPLORE BOTS
						</div>
						<div className="py-7px px-2 d-flex align-items-center">
							<i className="far fa-gem fa-lg fa-fw me-7px"></i>
							GO PRO
						</div>
					</div>
					
					<div className="p-2 bg-white bg-opacity-15">
						<div className="fw-semibold fs-11px flex-1 text-body d-flex align-items-center">
							<div className="w-30px h-30px fs-16px me-2 fw-400 rounded-circle text-white bg-white bg-opacity-15 d-flex align-items-center justify-content-center">
								S
							</div>
							support@seantheme.com
						</div>
					</div>
				</div>
			</div>
			
			<div className="flex-1 d-flex flex-column mw-100 h-100 ps-lg-2px">
				<div className="flex-1 overflow-hidden w-100 h-100 bg-white bg-opacity-10">
					<PerfectScrollbar className="h-100 p-2 p-lg-4" ref={messagesRef}>
						<div className="tab-content p-5">
							<div id="aiChatIntro" className={((activeTab === 'aiChatIntro') ? 'show active' : 'd-none') + ' tab-pane fade'}>
								<div className="display-5 fw-semibold mb-0">
									<span className="text-theme">Hello, there</span>
								</div>
								<div className="fs-3 text-body mb-5">How can I assist you today?</div>
								<div className="row g-4">
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Suggest hidden gems and must-see spots for my next trip.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:calendar-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Plan My Adventure</div>
												<div className="fs-15px text-body fw-semibold">Suggest hidden gems and must-see spots for my next trip.</div>
											</div>
										</a>
									</div>
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Create a concise and professional response for any situation.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:chats-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Draft a Quick Reply</div>
												<div className="fs-15px text-body fw-semibold">Create a concise and professional response for any situation.</div>
											</div>
										</a>
									</div>
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Break down complex ideas into simple, easy-to-understand explanations.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:codesandbox-logo-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Simplify This</div>
												<div className="fs-15px text-body fw-semibold">Break down complex ideas into simple, easy-to-understand explanations.</div>
											</div>
										</a>
									</div>
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Write and troubleshoot code with smart fixes for tricky errors.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:code-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Code & Debug</div>
												<div className="fs-15px text-body fw-semibold">Write and troubleshoot code with smart fixes for tricky errors.</div>
											</div>
										</a>
									</div>
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Generate fresh ideas for projects, names, or creative solutions.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:lightbulb-filament-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Brainstorm Anything</div>
												<div className="fs-15px text-body fw-semibold">Generate fresh ideas for projects, names, or creative solutions.</div>
											</div>
										</a>
									</div>
									<div className="col-sm-6 col-xl-4">
										<a href="#/" className="card cursor-pointer h-100 hover-bg-white bg-opacity-15 position-relative overflow-hidden text-decoration-none" onClick={(e) => { toggleAiTab(e, 'aiChatNew', 'Craft emails, reports, or social posts in a polished, clear tone.')}}>
											<div className="card-body p-5">
												<div className="mb-3 d-flex">
													<Icon icon="ph:open-ai-logo-duotone" className="fs-42px text-theme ms-n2"></Icon>
												</div>
												<div className="text-body text-opacity-50 fw-semibold mb-1">Write It for Me</div>
												<div className="fs-15px text-body fw-semibold">Craft emails, reports, or social posts in a polished, clear tone.</div>
											</div>
										</a>
									</div>
								</div>
							</div>
							
							<div id="aiChatPrev" className={((activeTab === 'aiChatPrev') ? 'show active' : 'd-none') + ' tab-pane fade'}>
								<div className="d-flex justify-content-end align-items-end mb-3">
									<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
										Can you generate some content for social media captions?
									</div>
									<div>
										<div className="w-30px h-30px mx-2 text-white rounded-circle bg-white bg-opacity-15 fs-16px d-flex align-items-center justify-content-center">
											S
										</div>
									</div>
								</div>
								
								<div className="mb-3">
									<div className="d-flex justify-content-start align-items-end">
										<div>
											<div className="w-30px h-30px mx-2 fs-16px rounded-circle bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center">
												<i className="fa fa-shekel-sign"></i>
											</div>
										</div>
										<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
											<div>Absolutely! What’s the topic or product?</div>
										</div>
									</div>
									<div className="d-flex">
										<div className="w-30px h-30px mx-3"></div>
										<div className="d-flex flex-wrap w-100 p-2 opacity-75">
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-copy"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-up"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-down"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="fa fa-fw fa-microphone"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration"><i className="fa fa-fw fa-arrow-rotate-right"></i></a>
										</div>
									</div>
								</div>
		
								<div className="d-flex justify-content-end align-items-end mb-3">
									<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
										Let’s say… a coffee shop promotion.
									</div>
									<div>
										<div className="w-30px h-30px mx-2 text-white rounded-circle bg-white bg-opacity-15 fs-16px d-flex align-items-center justify-content-center">
											S
										</div>
									</div>
								</div>
								
								<div className="mb-3">
									<div className="d-flex justify-content-start align-items-end">
										<div>
											<div className="w-30px h-30px mx-2 fs-16px rounded-circle bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center">
												<i className="fa fa-shekel-sign"></i>
											</div>
										</div>
										<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
											<div>How about these:</div>
											<ol className="my-2 ps-4">
												<li>Start your day with the perfect brew – 20% off all lattes today!</li>
												<li>Coffee first, everything else later. Grab your cup now!</li>
												<li>A little caffeine, a lot of happiness. Visit us for your daily fix!</li>
											</ol>
											<div>Need more options?</div>
										</div>
									</div>
									<div className="d-flex">
										<div className="w-30px h-30px mx-3"></div>
										<div className="d-flex flex-wrap w-100 p-2 opacity-75">
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-copy"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-up"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-down"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="fa fa-fw fa-microphone"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration"><i className="fa fa-fw fa-arrow-rotate-right"></i></a>
										</div>
									</div>
								</div>
		
								<div className="d-flex justify-content-end align-items-end mb-3">
									<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
										How can I fetch API data in Vue.js?
									</div>
									<div>
										<div className="w-30px h-30px mx-2 text-white rounded-circle bg-white bg-opacity-15 fs-16px d-flex align-items-center justify-content-center">
											S
										</div>
									</div>
								</div>
								
								<div className="mb-3">
									<div className="d-flex justify-content-start align-items-end">
										<div>
											<div className="w-30px h-30px mx-2 fs-16px rounded-circle bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center">
												<i className="fa fa-shekel-sign"></i>
											</div>
										</div>
										<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
											Here’s a simple example:
											<div className="card my-2">
												<div className="card-header d-flex">
													<span className="flex-1">vue</span>
													<span><a href="#/" className="text-body text-decoration-none"><i className="far fa-copy"></i> Copy</a></span>
												</div>
												<div className="hljs-container p-3 bg-black bg-opacity-50">
													<Highlight className='html'>&lt;script&gt;<br />
&nbsp;&nbsp;export default {"{"}<br />
&nbsp;&nbsp;&nbsp;&nbsp;async mounted() {"{"}<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;const response = await fetch('https://api.example.com/data');<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;const data = await response.json();<br />
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;console.log(data);<br />
&nbsp;&nbsp;&nbsp;&nbsp;{"}"}<br />
&nbsp;&nbsp;{"}"}<br />
&lt;/script&gt;</Highlight>
												</div>
											</div>
											Would you like me to explain how this works?
										</div>
									</div>
									<div className="d-flex">
										<div className="w-30px h-30px mx-3"></div>
										<div className="d-flex flex-wrap w-100 p-2 opacity-75">
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-copy"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-up"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="far fa-fw fa-thumbs-down"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration me-2"><i className="fa fa-fw fa-microphone"></i></a>
											<a href="#/" className="text-white text-opacity-50 text-decoration"><i className="fa fa-fw fa-arrow-rotate-right"></i></a>
										</div>
									</div>
								</div>
							</div>
							
							<div id="aiChatNew" className={((activeTab === 'aiChatNew') ? 'show active' : 'd-none') + ' tab-pane fade'}>
								{messages.map((msg, index) => (
									<div key={index} className={((msg.type === 'user') ? ' justify-content-end ' : ' justify-content-start ') + ((msg.type === 'typing') ? 'ai-spinner ' : '') + 'd-flex align-items-end mb-3'}>
										{msg.type === "user" && (
											<>
												<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">{msg.text}</div>
												<div className="w-30px h-30px mx-2 text-white rounded-circle bg-white bg-opacity-15 fs-16px d-flex align-items-center justify-content-center">
													S
												</div>
											</>
										)}
				
										{msg.type === "ai" && (
											<>
												<div className="w-30px h-30px mx-2 fs-16px rounded-circle bg-theme bg-opacity-15 text-theme d-flex align-items-center justify-content-center">
													<i className="fa fa-shekel-sign"></i>
												</div>
												<div className="px-3 py-6px text-body bg-white bg-opacity-15 mw-75">
													<div className="typing-animation" style={{ animationDuration: ".5s" }}>{msg.text}</div>
												</div>
											</>
										)}
				
										{msg.type === "typing" && (
											<div className="px-2">
												<div className="spinner-grow spinner-grow-sm"></div>
											</div>
										)}
									</div>
								))}
							</div>
						</div>
					</PerfectScrollbar>
				</div>
				
				<div className="mt-2px">
					<div className="p-4 bg-white bg-opacity-15">
						<div className="position-relative h-100">
							<div className="position-absolute start-0 bottom-0 d-flex">
								<button type="button" className="btn btn-lg text-body text-opacity-50 p-0 h-30px d-flex align-items-center justify-content-center me-3"><i className="fa fa-fw fa-plus"></i></button>
								<button type="button" className="btn btn-lg text-body text-opacity-50 p-0 h-30px d-flex align-items-center justify-content-center me-3"><i className="fa fa-fw fa-globe"></i></button>
								<button type="button" className="btn btn-lg text-body text-opacity-50 p-0 h-30px d-flex align-items-center justify-content-center"><i className="fa fa-fw fa-microphone"></i></button>
							</div>
							<input type="text" className="form-control form-control-lg fs-6 shadow-none border-0 px-1 pt-0" style={{ paddingBottom: '80px' }} value={inputValue} onChange={handleInputChange} onKeyPress={handleKeyPress} id="userInput" placeholder="Message AI Bot" />
							<div className="position-absolute end-0 bottom-0 px-1 pb-2" style={{ zIndex: '1050' }}>
								<button id="sendButton" onClick={handleSendMessage} className="btn btn-lg border-0 btn-theme">
									<i className="fa fa-arrow-right"></i>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default AiChat;